export enum EditorBridgeMessageType {
  ClientToEditorInvokation = 'client-to-editor-invokation',
  EditorToClientInvokation = 'editor-to-client-invokation',
  ClientToEditorReply = 'client-to-editor-reply',
  EditorToClientReply = 'editor-to-client-reply',
}
